import { sync } from 'vuex-pathify';

import Message from '@/vuex/orm/models/Message';

export default {

  data() {
    return {
      debugMessages: 0,
      fetchingMessages: false,
    };
  },

  computed: {
    ...sync([
      'chat/limit', //
    ]),
  },

  methods: {
    messagesIsEmpty() {
      return Message.all().length === 0;
    },

    async loadMessages(chatroomId, limit) {
      if (this.fetchingMessages) {
        return;
      }

      if (this.debugMessages) {
        console.log('messages requested!');
      }

      this.fetchMessages(chatroomId, limit);
    },

    async fetchMessages(chatroomId, limit) {
      if (this.debugMessages) {
        console.log(`fetching ${this.limit} messages from room ${chatroomId}...`);
      }

      this.fetchingMessages = true;

      await Message.api().get(`/api/chat/${chatroomId}/messages`, {
        params: {
          limit,
        },
      });

      if (this.debugMessages) {
        console.log('messages fetched!');
      }

      this.fetchingMessages = false;

      this.messagesRefreshed(chatroomId);
    },

    messagesRefreshed(chatroomId) {
      Bus.$emit('loading', false);

      if (this.debugMessages) {
        console.log('messages-loader.messages[0]', Message.query().where('chatroomId', chatroomId).first());
        console.log('messages-loader.messages', Message.query().where('chatroomId', chatroomId).get());
        console.log('messages-loader.messages.count', Message.query().where('chatroomId', chatroomId).count());
      }

      Bus.$emit('messages:refreshed', chatroomId);
    },
  },
};
